import { render } from "./TestPageNotFoundView.vue?vue&type=template&id=3def4e49"
import script from "./TestPageNotFoundView.vue?vue&type=script&lang=js"
export * from "./TestPageNotFoundView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__